export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5233.82ff0b7e.jpg";